import React from 'react';
import { OverviewComponentType, ProductOverviewRegistry } from '../../types';
import AppPerformanceOverviewCommon from '../../../../containers/OverView/AppPerformanceOverviewCommon';
import GPGValueCreationScorecard from '../../../../containers/OverView/GPGOverview/GPGValueCreationScorecard';
import GPGUserAdoptionScorecard from '../../../../containers/OverView/GPGOverview/GPGUserAdoptionScorecard';

const scorecards: OverviewComponentType[] = [
  () => <GPGValueCreationScorecard />,
  () => <AppPerformanceOverviewCommon />,
  () => <GPGUserAdoptionScorecard />,
];
/**
 * GPG program overview registry
 */
const gpgRegistry: ProductOverviewRegistry = {
  scorecards: scorecards,
  customOverview: null, // Removing from customOverview since it's now in scorecards
};

export default gpgRegistry;
